import { render, staticRenderFns } from "./ChromatogramsCompare.vue?vue&type=template&id=22cd9b8a&scoped=true&"
import script from "./ChromatogramsCompare.vue?vue&type=script&lang=js&"
export * from "./ChromatogramsCompare.vue?vue&type=script&lang=js&"
import style0 from "./ChromatogramsCompare.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ChromatogramsCompare.vue?vue&type=style&index=1&id=22cd9b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd9b8a",
  null
  
)

export default component.exports